import React, { useState, useEffect, useRef } from 'react'
import { Button, Col, Card } from 'antd'
import { paginationInit, formatMessage, downLoadFileBlob } from '../../utils/common'
import { SearchOutlined } from '@ant-design/icons'
import AntdTable from '../../components/table/AntdTable'
import SearchBar from '../../components/searchbar/SearchBar'
import { useSelector } from 'react-redux'
import {
  getSeasonList,
  getStoreConfigList,
  exportStoreConfig,
  importStoreConfig,
  downloadStoreLatest
} from '../../services/configuration/config'
import UploadBtn from '../../components/Upload/Upload'
import { modalErrorRefreshCode, modalSuccess } from '../../utils/modalUtils'
import { hasPermission } from '@/annotations/nike-react'
const menu_nfc_configuration_storeDisplay = 'menu_nfc_configuration_storeDisplay'
const colLayout = { xs: 24, sm: 12, md: 12, lg: 8, xl: 6, xxl: 6 }

const StoreDisplayPage = () => {
  const commonStore = useSelector(state => state.commonStore)
  const language = useSelector(state => state.commonStore.language)
  let formRef = useRef(null)
  const tableColumns = [
    {
      title: formatMessage(commonStore, 'languageObj.configuration.season'),
      dataIndex: 'season'
    },
    {
      title: formatMessage(commonStore, 'languageObj.configuration.salesDoor'),
      dataIndex: 'salesDoor'
    },
    {
      title: formatMessage(commonStore, 'languageObj.configuration.averageNo'),
      dataIndex: 'averageNo'
    },
    {
      title: formatMessage(commonStore, 'languageObj.commonLocale.productCode'),
      dataIndex: 'productCode'
    },
    {
      title: formatMessage(commonStore, 'languageObj.configuration.channel'),
      dataIndex: 'channel'
    },
    {
      title: formatMessage(commonStore, 'languageObj.configuration.lastUploadTime'),
      dataIndex: 'updateTime'
    }
  ]

  const searchListInit = [
    {
      type: 'select',
      label: 'languageObj.configuration.season',
      key: 'seasons',
      initialValues: [],
      mode: 'multiple',
      selectList: [],
      spans: { xl: 7, xxl: 7 }
    }
  ]
  const [searchList, setSearchList] = useState(searchListInit)
  const [tableList, setTableList] = useState([])
  const [queryFlag, setQueryFlag] = useState(false)
  const [pagination, setPagination] = useState(paginationInit)

  useEffect(() => {
    initSeasonList()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    searchDataFun()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [queryFlag])

  const initSeasonList = () => {
    getSeasonList().then(res => {
      const options = res.resultData.map(item => ({ label: item, value: item }))
      searchListInit.forEach(item => {
        if (item.key === 'seasons') item.selectList = options
      })
      setSearchList([...searchListInit])
    })
  }

  const getParams = () => {
    const info = (formRef.current && formRef.current.getValue()) || {}
    const params = {
      isChinese: language === 'zh_CN' ? true : false,
      seasons: info.seasons
    }
    return params
  }

  const searchDataBtn = () => {
    const pg = { ...pagination, currentPage: 1 }
    setPagination(pg)
    setQueryFlag(!queryFlag)
  }

  const handleTableChange = pagina => {
    const { current, pageSize } = pagina
    const params = { ...pagination, currentPage: current, pageSize }
    setPagination({ ...params })
    setQueryFlag(!queryFlag)
  }
  const searchDataFun = () => {
    const { currentPage, pageSize, total } = pagination
    const params = { ...getParams(), pageNo: currentPage, size: pageSize, total }
    getStoreConfigList(params).then(res => {
      if (!res) return
      const dt = res.resultData
      const { records, total } = dt
      setTableList(records)
      setPagination({ ...pagination, total })
    })
  }
  const exportData = () => {
    const params = getParams()
    exportStoreConfig(params).then(res => {
      downLoadFileBlob(res)
    })
  }

  const uploadFun = file => {
    importStoreConfig(file)
      .then(res => {
        if (res.errorCode !== '200') return
        modalSuccess({ content: formatMessage(commonStore, 'languageObj.configuration.uploadSuccess') })
        initSeasonList()
        searchDataBtn()
      })
      .catch(error => {
        if (!error) return
        const { errorCode, resultData } = error
        if (errorCode !== '500' || !resultData) return
        const codes = Object.keys(resultData)
        if (!codes.length) return
        let msg = ''
        codes.forEach(code => {
          const info = formatMessage(commonStore, `languageObj.configuration.uploadStoreDisplay_errorcode_${code}`)
          if (code === '507') {
            resultData[code] &&
              resultData[code].forEach(item => {
                msg += `${item} ${info}<br>`
              })
            return
          }
          msg += `${info}<br>`
        })
        modalErrorRefreshCode({ content: msg })
      })
  }

  const downloadLatest = () => {
    const params = { isChinese: language === 'zh_CN' ? true : false }
    downloadStoreLatest(params).then(res => {
      downLoadFileBlob(res)
    })
  }

  return (
    <div>
      <Card bordered={false} bodyStyle={{ padding: 4 }}>
        <div className="search-bar">
          <SearchBar ref={formRef} searchList={searchList}>
            <Col {...colLayout} className="right_search" style={{ justifyContent: 'flex-end' }}>
              <Button icon={<SearchOutlined />} type="primary" onClick={searchDataBtn}>
                {formatMessage(commonStore, 'languageObj.commonLocale.search')}
              </Button>
              <Button onClick={exportData}>{formatMessage(commonStore, 'languageObj.configuration.export')}</Button>
            </Col>
          </SearchBar>
        </div>
        <div className="content-container">
          <div className="opt_btn mb15" style={{ display: 'flex' }}>
            {hasPermission(menu_nfc_configuration_storeDisplay) ? (
              <div>
                <UploadBtn
                  uploadAjax={file => uploadFun(file)}
                  btnName={formatMessage(commonStore, 'languageObj.configuration.upload')}
                />
              </div>
            ) : null}
            <Button type="primary" onClick={downloadLatest} style={{ marginLeft: '20px' }}>
              {formatMessage(commonStore, 'languageObj.configuration.exportLatestStoreDisplay')}
            </Button>
          </div>
          <AntdTable
            rowKey={record => record.id}
            dataSource={tableList}
            columns={tableColumns}
            pagination={pagination}
            onChange={handleTableChange}
          />
        </div>
      </Card>
    </div>
  )
}
export default StoreDisplayPage
